import clsx from 'clsx';
import Icon from '../../../icons/Icon';

import scss from './IconTab.module.scss';

function IconTab({ label, icon }) {
  return (
    <div className={scss.wrapper}>
      <Icon icon={icon} disableCommonStyles className={clsx(scss.icon)} />
      {label}
    </div>
  );
}

export default IconTab;
